import { isPlatformBrowser, NgClass, AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener, OnDestroy, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { CustomerService } from '../../_shared/_services/customer.service';
import { CartService } from '../../_shared/_services/cart.service';
import { SidenavService } from '../sidenav/sidenav.service';
import { IShopifyCart, IShopifyCustomer } from '@app/_shared/_models';
import { Router, RouterLink } from '@angular/router';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { SearchBarComponent } from '../../_shared/_components/search/search-bar.component';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatBadge } from '@angular/material/badge';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatToolbar, RouterLink, SearchBarComponent, NgClass, MatButton, MatIconButton, MatMenuTrigger, MatIcon, MatTooltip, MatBadge, MatToolbarRow, MatMenu, MatMenuItem, AsyncPipe]
})
export class NavbarComponent implements OnInit, OnDestroy {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly cartService = inject(CartService);
  private readonly sidenavService = inject(SidenavService);
  private readonly customerService = inject(CustomerService);
  private readonly router = inject(Router);

  public cart$: Observable<IShopifyCart | undefined>;
  public customer$: Observable<IShopifyCustomer | undefined>;
  public isFixed = false;
  public hideOnScrollDown = true;
  public scrollingDown = false;
  public preventNavbarVisibility = false;

  private readonly unsubscribe: Subject<undefined> = new Subject<undefined>();
  private lastScrollTop = 0;

  @HostListener('window:scroll', ['$event']) public onScroll(_event: any): void {
    if (isPlatformBrowser(this.platformId) && this.hideOnScrollDown) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.lastScrollTop && scrollTop > 85){
        this.scrollingDown = true;
      } else if (scrollTop === 0 || !this.preventNavbarVisibility) {
        this.scrollingDown = false;
      } else {
        this.preventNavbarVisibility = false;
      }
      this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }
  }

  constructor() {
    this.cart$ = this.cartService.cart$;
    this.customer$ = this.customerService.customer$;
  }

  ngOnInit(): void {
    this.cart$
      ?.pipe(takeUntil(this.unsubscribe))
      .subscribe((cart: IShopifyCart | undefined) => {
        this.scrollingDown = false;
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }

  public toggleSidenav(): void {
    this.sidenavService.toggle();
  }
  
  public openLogin() {
    this.customerService.openLogin();
  }

  public openCart() {
    this.cartService.openDialog();
  }

  public async logout(): Promise<void> {
    const didSucceed = await this.customerService.logout();

    if (didSucceed) {
      if (this.router.url?.includes('/orders')) {
        await this.router.navigate(['/']);
      }
    }
  }

}
